import axios from '../script/axiosAMS'

export default {
  getMenuInfo (params, resultCallback) {
    axios.requestWith({
      url: '/api/menu',
      method: 'get',
      params: params,
      resultCallback: resultCallback
    })
  },
  menuInfo (method, data, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/menu',
      method: method,
      data: data,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  },
  bulkUpdateModemInfo (data, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/modem',
      method: 'post',
      data: data,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  }
}



// WEBPACK FOOTER //
// ./src/script/menuInfo.js